module.exports = __webpack_public_path__ + "media/images/landing/dashboard-d9bd6523dd42c3bd83ed7b1df44755f0.png";